import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionDisplayServiceTsService {
  private versionSubject = new BehaviorSubject<string>('—');
  readonly version$ = this.versionSubject.asObservable();

  constructor(private http: HttpClient) {
    this.loadVersion();
  }

  private loadVersion() {
    const url = `assets/version.json?v=${Date.now()}`;

    this.http.get<{ version: string; buildTime?: string }>(url).subscribe({
      next: (res) => {
        const raw = res?.version ?? 'N/A';
        const clean = typeof raw === 'string' ? raw.split('+')[0] : 'N/A';
        this.versionSubject.next(clean);
      },
      error: (err) => {
        console.error('[VersionDisplay] failed to load version.json:', err);
        this.versionSubject.next('N/A');
      },
    });
  }
}